<template>
  <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 21C2.89543 21 2 20.1046 2 19V3H11L16 8V19C16 20.1046 15.1046 21 14 21H4Z" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 3V9H16" stroke="#292929" stroke-width="2" stroke-linejoin="round"/>
    <circle cx="8" cy="17" r="1" stroke="#292929" stroke-width="2"/>
    <path d="M9 12V17" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11 14L9 12" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
